module.exports = __webpack_public_path__ + "public/media/facebook.png";


//////////////////
// WEBPACK FOOTER
// ./images/facebook.png
// module id = ./images/facebook.png
// module chunks = 0